export const parseStringToBoolean = string => {
  return !!string ? string.toLowerCase() === "true" : false;
};
